import React from "react"
import {useTranslation} from "react-i18next"
import {twMerge} from "tailwind-merge"

export const EmptyState: React.FC<{message?: React.ReactNode; className?: string}> = ({message, className}) => {
  const {t} = useTranslation()

  return (
    <div
      className={twMerge("flex h-full items-center justify-center text-center text-[12px] text-cr-slate-60", className)}
    >
      {message ?? t("ReachEngine_EmptyState")}
    </div>
  )
}
